import {DocumentsBatch, VersionedHbeDocument} from '../../types';
import React, {useState} from 'react';
import {selectedDocument} from './index';
import {formatDateTime} from '../../utils/dateUtils';
import './AvailableDocuments.scss'
import {ReactComponent as ClockIcon} from './images/clock.svg'
import {ErrorDocDialog} from "../../components/error_doc_dialog/ErrorDocDialog";

interface AvailableDocumentsProps {
    docs: DocumentsBatch
    setSelectedDocument: React.Dispatch<React.SetStateAction<selectedDocument>>
    className?: string;
}

export const AvailableDocuments: React.FC<AvailableDocumentsProps> = ({docs, setSelectedDocument, className}) => {
    const [selectedVersion, setSelectedVersion] = useState<number>(docs.documents[0].version);


    const selectDocument = (doc: VersionedHbeDocument) => {
        setSelectedDocument(prevDocument => {
            if (prevDocument) {
                return {
                    ...prevDocument,
                    ...{
                        document: doc,
                        documentTypeName: docs.documentsType,
                    }
                }
            }
            return prevDocument
        });
    }

    const items = docs.documents.map((data, key) => {
                if (+new Date(data.version * 1000) === 0) {
                    return null;
                }

                return <li key={key} className={`doc-versions__item ${data.version === selectedVersion ? 'active' : ''}`}>
                    <ClockIcon/>
                    <button
                            className="text-left"
                            onClick={() => {
                                selectDocument(data)
                                setSelectedVersion(data.version)
                            }}>
                        {formatDateTime(new Date(data.version * 1000))}
                    </button>
                </li>;
            }
    );

    if (!docs) return (<></>)

    return (
            <div className={"doc-versions__wrap"}>
                <div className={`doc-versions ${className || ''}`}>
                    {items[0] &&
                            (<h5 className="doc-versions__title">
                                Другие версии документа:
                            </h5>)
                    }
                    <ul>
                        {items}
                        <li className="pl-2 mb-0">
                            <ErrorDocDialog documentId={docs.documentId}
                                            documentVersion={selectedVersion}
                            />
                        </li>
                    </ul>
                </div>
            </div>
    )
}
